

export const configs_gtdc_annoBase = {
  contentTypes: {
},
  filterDefs: {
    whitelist: [
    ],
  },
  getDataConfig: {
    rollupInjectProperty: [{ isAnno: true, rollupType: 'tagType', path: ['themeTags', 'themes'] }]
  },
 
  cardConfigs: {  
    
  },
  // cardConfigs: {  
  //   metaBlock: [
  //     { 
  //       prefix: 'Pathway Segment: ',
  //       key: 'text',
  //       valuePath: ['tags.segmentKenya.data.0.display', 'tags.segmentationNigeria.data.0.display', 'tags.segmentationSenegal.data.0.display']
  //     }
  //   ],
  //   disableTagsSection: true,
  //   tags: {
  //       whitelist: [
  //           // 'documentStatus'
  //       ]
  //   },
  //   annoTags: {
  //       whitelist: []
  //   }
  // },
};
